import React from 'react'

import styled from '@emotion/styled';
import { mq, baseDurationTime, pcHeaderH, spHeaderH } from '../../_style';
import Header from '../organisms/header';

const Container = styled.div`
  position: ${props => props.status === 'entered' || props.status === 'entering' ? 'relative' : 'absolute'};
  ${props => props.status === 'exiting' && `top: ${-1 * props.top + pcHeaderH}px`};
  left: 0;
  width: 100%;
  pointer-events: ${props => props.status === 'entered' ? 'auto' : 'none'};
  opacity: ${props => props.status === 'entered' ? '1' : '0'};
  transition: opacity ${baseDurationTime} ease;
  ${mq.sp} {
    ${props => props.status === 'exiting' && `top: ${-1 * props.top + spHeaderH}px`};
  }
  [data-block-header] & {
    padding-top: 104px;
    ${mq.sp} {
      padding-top: 97px;
    }
  }
`

export default class Page extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
  }
  componentWillUnmount() {
  }
  render() {
    const { transitionStatus } = this.props;
    return(
      <Container className={this.props.className} status={this.props.transitionStatus} top={this.props.top}>
        <Header></Header>
        {this.props.children}
      </Container>
    )
  }
}
